/**
 * Vanilla search-input binding. iOS keyboards fire inconsistently on `input`;
 * also listen for keyup/change/search so type-to-filter works without jQuery.
 * Duplicate events with the same value are ignored so blur/`change` cannot
 * re-run a live catalog search and reset pagination.
 */

export function bindSearchInput(input, onQuery) {
  if (!input || input.getAttribute('data-hs-search-bound') === '1') {
    return;
  }

  input.setAttribute('data-hs-search-bound', '1');

  let lastEmitted = input.value || '';

  const emit = function emitQuery() {
    const value = input.value || '';
    if (value === lastEmitted) {
      return;
    }

    lastEmitted = value;
    onQuery(value);
  };

  input.addEventListener('input', emit);
  input.addEventListener('keyup', emit);
  input.addEventListener('change', emit);
  input.addEventListener('search', emit);
}

export function debounce(fn, waitMs) {
  let timer = null;

  return function debounced() {
    const args = arguments;
    const context = this;

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(function runDebounced() {
      timer = null;
      fn.apply(context, args);
    }, waitMs);
  };
}
